import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import queryString from "query-string";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";



import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import { useInvoicePDF } from "../../../customHooks/useInvoicePDF";
import { ColoredButton, PrimaryBgButton, PrimaryWhiteBgButton } from "../../../styledComponents/buttons";
import { CommonFlex, CommonGrid, Container, ContainerNew, PageTitle } from "../../../styledComponents/common";
import { ClientViewContainer } from "../../../styledComponents/invoice";
import { currencySymbolMap } from "../../../utils/currencies";
import { globalDateFormat } from "../../../utils/helper";
import PreviewPDFView from "../PreviewPDFView";
import SendMailPopup from "../SendMailPopup";


pdfMake.vfs = pdfFonts.pdfMake.vfs;

const InvoiceClientView = ({
  selectedOrganization,
  location,
  invoiceDetails,
  invoiceConfig,
  isLoading,
  history,
  profileData,
  sendMailLoading,
  updateInvoiceSendLog,
  createInvoiceUpdateSendLog,
  sendInvoiceEmail,
  getInvoiceDetails,
  getInvoiceConfig,
}) => {
  const { t } = useTranslation();

  const { downloadPDF, printPDF, isGenerating } = useInvoicePDF();
  const [sendEmailOpen, setSendEmailOpen] = useState(false);
  const [sentState, setSentState] = useState(false);
  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      if (location.search) {
        const queryParsed = queryString.parse(location.search);
        let payload = {
          organization_id: selectedOrganization.id,
          invoice_id: queryParsed.id,
        };
        getInvoiceDetails(payload);
        getInvoiceConfig(payload);
      }
    }
  }, [selectedOrganization, getInvoiceDetails, getInvoiceConfig, location.search]);

  // Handler for downloading PDF with error handling
  const handleDownloadPDF = async e => {
    e.preventDefault();
    try {
      const filename = `invoice-${invoiceDetails.invoice_number}.pdf`;
      const success = await downloadPDF(
        invoiceDetails,
        invoiceConfig,
        filename,
      );
      if (!success) {
        console.error('PDF download failed: Unknown error');
      }
    } catch (error) {
      console.error('PDF download failed:', error);
    }
  };

  // Handler for printing PDF with error handling
  const handlePrintPDF = async e => {
    e.preventDefault();
    try {
      const success = await printPDF(invoiceDetails, invoiceConfig);
      if (!success) {
        console.error('PDF print failed: Unknown error');
      }
    } catch (error) {
      console.error('PDF print failed:', error);
    }
  };

  // useEffect(() => {
  // }, [props.invoiceDetails]);

  // const handleDownloadPDF = type => {
  //   let info = { ...props.invoiceDetails };
  //   info.items.forEach((item, index) => {
  //     item.no = index + 1;
  //     delete item.tax1;
  //     delete item.tax2;
  //   });

  //   const downloadPdf = () => {
  //     Object.byString = function (o, s) {
  //       s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
  //       s = s.replace(/^\./, ""); // strip a leading dot
  //       var a = s.split(".");
  //       for (var i = 0, n = a.length; i < n; ++i) {
  //         var k = a[i];
  //         if (k in o) {
  //           o = o[k];
  //         } else {
  //           return;
  //         }
  //       }
  //       return o;
  //     };

  //     function buildTableBody(data, columns, showHeaders, headers) {
  //       var body = [];
  //       // Inserting headers
  //       if (showHeaders) {
  //         body.push(headers);
  //       }

  //       // Inserting items from external data array
  //       data.forEach(function (row) {
  //         var dataRow = [];
  //         var i = 0;

  //         columns.forEach(function (column) {
  //           dataRow.push({
  //             text: Object.byString(row, column),
  //             alignment: headers[i].alignmentChild,
  //             color: "#2f394e",
  //             fontSize: 11,
  //             margin: [0, 6, 0, 7],
  //           });
  //           i++;
  //         });
  //         body.push(dataRow);
  //       });

  //       return body;
  //     }

  //     function table(
  //       data,
  //       columns,
  //       witdhsDef,
  //       showHeaders,
  //       headers,
  //       layoutDef,
  //     ) {
  //       return {
  //         table: {
  //           headerRows: 1,
  //           margin: [0, 5, 0, 15],
  //           widths: witdhsDef,
  //           body: buildTableBody(data, columns, showHeaders, headers),
  //         },
  //         layout: layoutDef,
  //       };
  //     }

  //     let docDefinition = {
  //       pageSize: "A4",
  //       pageOrientation: "landscape",
  //       pageMargins: [25, 20, 25, 30],
  //       footer: {
  //         columns: [
  //           {
  //             style: "footer",
  //             text: [
  //               "Powered by ",
  //               {
  //                 text: "Apploye",
  //                 link: "https://apploye.com/",
  //                 color: "#20bead",
  //                 bold: true,
  //               },
  //             ],
  //             alignment: "left",
  //           },
  //         ],
  //       },
  //       content: [
  //         {
  //           margin: [0, 0, 0, 15],
  //           fontSize: 11,
  //           color: "#2f394e",
  //           table: {
  //             widths: [`*`, `auto`],
  //             body: [
  //               [
  //                 {
  //                   rowSpan: 2,
  //                   text: `Invoice ${info.invoice_number}`,
  //                   bold: true,
  //                   fontSize: 24,
  //                 },
  //                 {
  //                   text: props.selectedOrganization.name,
  //                   noWrap: true,
  //                   fontSize: 15,
  //                   alignment: "right",
  //                 },
  //               ],
  //               [
  //                 "",
  //                 {
  //                   text: props.selectedOrganization.address,
  //                   alignment: "right",
  //                 },
  //               ],
  //             ],
  //           },
  //           layout: "noBorders",
  //         },
  //         {
  //           image: `data:image/png;base64,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`,
  //           width: "790",
  //         },
  //         {
  //           style: `tableExample`,
  //           table: {
  //             widths: [`*`, `*`, `*`, "*", "*"],
  //             body: [
  //               [
  //                 {
  //                   style: "upperInfoTitle",
  //                   text: [
  //                     "Amount Due ",
  //                     `(${currencySymbolMap[info.currency]})`,
  //                   ],
  //                   noWrap: true,
  //                 },
  //                 {
  //                   style: "upperInfoTitle",
  //                   text: "Invoice Number",
  //                   noWrap: true,
  //                 },
  //                 {
  //                   style: "upperInfoTitle",
  //                   text: "Billed To",
  //                   noWrap: true,
  //                 },
  //                 {
  //                   style: "upperInfoTitle",
  //                   text: "Issued Date",
  //                   noWrap: true,
  //                 },
  //                 {
  //                   style: "upperInfoTitle",
  //                   text: "Due Date",
  //                   noWrap: true,
  //                 },
  //               ],
  //               [
  //                 {
  //                   text: `${info.currency} (${
  //                     currencySymbolMap[info.currency]
  //                   }) ${
  //                     (
  //                       parseFloat(info.discounted_amount) -
  //                       parseFloat(info.paid_amount)
  //                     ).toFixed(2) > 0
  //                       ? (
  //                           parseFloat(info.discounted_amount) -
  //                           parseFloat(info.paid_amount)
  //                         ).toFixed(2)
  //                       : 0
  //                   }`,
  //                   fontSize: 16,
  //                   bold: true,
  //                 },
  //                 { text: info.invoice_number },
  //                 info.client_name,
  //                 globalDateFormat(info.issued_date),
  //                 info.due_date ? globalDateFormat(info.due_date) : "-",
  //               ],
  //             ],
  //           },
  //           layout: "noBorders",
  //         },

  //         table(
  //           // External data
  //           info.items,
  //           // Columns display order
  //           ["no", "type", "description", "quantity", "unit_price", "amount"],
  //           [20, 70, `*`, 80, 130, 100],
  //           // Show headers?
  //           true,
  //           // Custom headers
  //           [
  //             {
  //               text: "No.",
  //               color: "#9eafc2",
  //               bold: true,
  //               margin: [0, 15, 0, 10],
  //               fontSize: 11,
  //               noWrap: true,
  //               border: [false, false, false, true],
  //             },
  //             {
  //               text: "Type",
  //               color: "#9eafc2",
  //               bold: true,
  //               margin: [0, 15, 0, 10],
  //               fontSize: 11,
  //               noWrap: true,
  //               border: [false, false, false, true],
  //             },
  //             {
  //               text: "Item / Description",
  //               color: "#9eafc2",
  //               bold: true,
  //               margin: [0, 15, 0, 10],
  //               fontSize: 11,
  //               noWrap: true,
  //               border: [false, false, false, true],
  //             },
  //             {
  //               text: "Quantity",
  //               color: "#9eafc2",
  //               bold: true,
  //               margin: [0, 15, 0, 10],
  //               fontSize: 11,
  //               noWrap: true,
  //               border: [false, false, false, true],
  //             },
  //             {
  //               text: "Unit Price",
  //               color: "#9eafc2",
  //               bold: true,
  //               margin: [0, 15, 0, 10],
  //               fontSize: 11,
  //               noWrap: true,
  //               border: [false, false, false, true],
  //             },
  //             {
  //               text: "Amount",
  //               color: "#9eafc2",
  //               bold: true,
  //               margin: [0, 15, 0, 10],
  //               fontSize: 11,
  //               noWrap: true,
  //               border: [false, false, false, true],
  //             },
  //           ],
  //           {
  //             hLineWidth: function (i, node) {
  //               return i === 0 ? 0 : 1;
  //             },
  //             vLineWidth: function (i, node) {
  //               return 0;
  //             },
  //             hLineColor: function (i, node) {
  //               return "#C2CCE1";
  //             },
  //           },
  //         ),
  //         {
  //           style: `tableExample`,
  //           table: {
  //             widths: ["*", 130, 100],
  //             alignment: "right",
  //             body: [
  //               [
  //                 "",
  //                 {
  //                   style: "calculationTitle",
  //                   text: "Subtotal",
  //                   noWrap: true,
  //                 },
  //                 {
  //                   style: "calculationText",
  //                   text: `${currencySymbolMap[info.currency]} ${(
  //                     parseFloat(info.total_amount) -
  //                     parseFloat(info.total_tax1) -
  //                     parseFloat(info.total_tax2)
  //                   ).toFixed(2)}`,
  //                   bold: true,
  //                 },
  //               ],
  //               parseFloat(info.discount.percent_amount) > 0 ||
  //               parseFloat(info.discount.fixed_amount) > 0
  //                 ? [
  //                     "",
  //                     {
  //                       style: "calculationTitle",
  //                       text: [
  //                         "Discount ",
  //                         info.discount.type === "percent"
  //                           ? `(${info.discount.percent_amount}%)`
  //                           : "",
  //                       ],
  //                     },
  //                     {
  //                       style: "calculationText",
  //                       text: `-${currencySymbolMap[info.currency]} ${
  //                         info.discount.type === "percent"
  //                           ? (
  //                               parseFloat(info.total_amount) -
  //                               parseFloat(info.discounted_amount)
  //                             ).toFixed(2)
  //                           : parseFloat(info.discount.fixed_amount).toFixed(2)
  //                       }`,
  //                     },
  //                   ]
  //                 : [{ text: "" }, { text: "" }, { text: "" }],
  //               parseFloat(info.tax1.percent_amount) > 0 ||
  //               parseFloat(info.tax1.fixed_amount) > 0
  //                 ? [
  //                     "",
  //                     {
  //                       style: "calculationTitle",
  //                       text: [
  //                         info.tax1.name.toLowerCase() === "tax 1"
  //                           ? `Tax 1`
  //                           : `${info.tax1.name}`,
  //                         info.tax1.type === "percent"
  //                           ? ` (${info.tax1.percent_amount}%)`
  //                           : "",
  //                       ],
  //                     },
  //                     {
  //                       style: "calculationText",
  //                       text: `${currencySymbolMap[info.currency]} ${
  //                         info.total_tax1
  //                       }`,
  //                     },
  //                   ]
  //                 : [{ text: "" }, { text: "" }, { text: "" }],
  //               info.tax2 &&
  //               (parseFloat(info.tax2.percent_amount) > 0 ||
  //                 parseFloat(info.tax2.fixed_amount) > 0)
  //                 ? [
  //                     "",
  //                     {
  //                       style: "calculationTitle",
  //                       text: [
  //                         info.tax2 === null ||
  //                         info.tax2.name.toLowerCase() === "tax 2"
  //                           ? "Tax 2"
  //                           : `${info.tax2.name}`,
  //                         info.tax2 !== null && info.tax2.type === "percent"
  //                           ? ` (${info.tax2.percent_amount}%)`
  //                           : "",
  //                       ],
  //                     },
  //                     {
  //                       style: "calculationText",
  //                       text:
  //                         info.tax2 === null
  //                           ? "0.0"
  //                           : `${currencySymbolMap[info.currency]} ${
  //                               info.total_tax2
  //                             }`,
  //                     },
  //                   ]
  //                 : [{ text: "" }, { text: "" }, { text: "" }],
  //               [
  //                 "",
  //                 {
  //                   style: "calculationTitle",
  //                   text: "Grand Total",
  //                   noWrap: true,
  //                 },
  //                 {
  //                   style: "calculationText",
  //                   text: `${currencySymbolMap[info.currency]} ${parseFloat(
  //                     info.discounted_amount,
  //                   ).toFixed(2)}`,
  //                 },
  //               ],
  //               [
  //                 "",
  //                 {
  //                   style: "calculationTitle",
  //                   text: "Paid",
  //                   noWrap: true,
  //                 },
  //                 {
  //                   style: "calculationText",
  //                   text: `${currencySymbolMap[info.currency]} ${
  //                     info.paid_amount
  //                   }`,
  //                 },
  //               ],
  //               [
  //                 "",
  //                 {
  //                   style: "calculationTitle",
  //                   text: "Amount Due",
  //                   noWrap: true,
  //                 },
  //                 {
  //                   style: "calculationText",
  //                   text: `${info.currency} (${
  //                     currencySymbolMap[info.currency]
  //                   }) ${
  //                     (
  //                       parseFloat(info.discounted_amount) -
  //                       parseFloat(info.paid_amount)
  //                     ).toFixed(2) > 0
  //                       ? (
  //                           parseFloat(info.discounted_amount) -
  //                           parseFloat(info.paid_amount)
  //                         ).toFixed(2)
  //                       : 0
  //                   }`,
  //                   bold: true,
  //                 },
  //               ],
  //             ],
  //           },
  //           layout: {
  //             hLineWidth: function (i) {
  //               return i === 6 ? 1 : 0;
  //             },
  //             vLineWidth: function (i) {
  //               return 0;
  //             },
  //             hLineColor: function (i) {
  //               return "#C2CCE1";
  //             },
  //           },
  //         },
  //       ],
  //       styles: {
  //         tableExample: {
  //           margin: [0, 5, 0, 15],
  //           fontSize: 11,
  //           color: "#2f394e",
  //         },
  //         upperInfoTitle: {
  //           color: "#9eafc2",
  //           bold: true,
  //           margin: [0, 15, 0, 10],
  //         },
  //         ItemListTitle: {
  //           color: "#9eafc2",
  //           bold: true,
  //           margin: [0, 15, 0, 10],
  //           fontSize: 11,
  //         },
  //         calculationTitle: {
  //           color: "#9eafc2",
  //           bold: true,
  //           margin: [0, 7, 0, 5],
  //           fontSize: 11,
  //         },
  //         calculationText: {
  //           margin: [0, 7, 0, 5],
  //           fontSize: 11,
  //         },
  //         cellDesign: {
  //           margin: [0, 6, 0, 7],
  //           fontSize: 11,
  //         },
  //         footer: {
  //           fontSize: 11,
  //           color: "#2f394e",
  //           background: "#fff",
  //           margin: [25, 0, 0, 10],
  //         },
  //       },
  //       defaultStyle: {
  //         // alignment: 'justify'
  //       },
  //     };
  //     if (type === "print") {
  //       pdfMake.createPdf(docDefinition).print();
  //     } else {
  //       pdfMake
  //         .createPdf(docDefinition)
  //         .download(`invoice_${info.invoice_number}`);
  //     }
  //   };
  //   downloadPdf();
  // };

  const sendEmailToggle = () => {
    console.log("send Button clicked");
    setSendEmailOpen(!sendEmailOpen);
  };

  return (
    <div className="content">
      {selectedOrganization &&
        selectedOrganization.id &&
        invoiceDetails &&
        invoiceDetails.id && (
          <BackButtonComponent
            onClick={() =>
              history.push(
                `/user/invoice-preview?id=${invoiceDetails.id}`,
              )
            }
            subTitle="Back to invoice"
          />
        )}
      {invoiceDetails && invoiceDetails.id && profileData && (
        <SendMailPopup
          isOpen={sendEmailOpen}
          isLoading={sendMailLoading}
          toggle={sendEmailToggle}
          organization_id={selectedOrganization.id}
          organization_name={selectedOrganization.name}
          invoice_id={invoiceDetails.id}
          senderName={profileData.first_name}
          invoiceNumber={invoiceDetails.invoice_number}
          issuedDate={invoiceDetails.issued_date}
          dueDate={
            invoiceDetails.due_date ? invoiceDetails.due_date : null
          }
          email={
            invoiceDetails.client && invoiceDetails.client.email
          }
          log={updateInvoiceSendLog}
          createInvoiceUpdateSendLog={createInvoiceUpdateSendLog}
          sendInvoiceEmail={sendInvoiceEmail}
          onSend={() => setSentState(true)}
        />
      )}
      <ContainerNew marginTop="16px">
        <CommonGrid disableResponsive responsiveBreakpoint="590px" responsiveColumns="1fr" columns="auto auto" alignItem="center">
          <PageTitle>View as customer</PageTitle>
          <CommonGrid mobileColumns="1fr 1fr" columns="auto auto auto">
            <PrimaryWhiteBgButton
              disabled={isGenerating}
              onClick={handleDownloadPDF}
            >
              {isGenerating ? "Generating..." : t("download_pdf")}
            </PrimaryWhiteBgButton>
            <PrimaryWhiteBgButton
              disabled={isGenerating}
              onClick={handlePrintPDF}
            >
              {isGenerating ? "Generating..." : t("print_invoice")}
            </PrimaryWhiteBgButton>
            <PrimaryBgButton onClick={() => setSendEmailOpen(true)}>
              {t("email_invoice")}
            </PrimaryBgButton>
          </CommonGrid>
        </CommonGrid>
        <CommonFlex
          justifyContent="center"
          alignItems="center"
          marginTop="12px"
        >
          <Container
            borderRadious="16px 16px 0 0"
            showBorder
            marginTop="0px 0px 12px 0"
            style={{
              minWidth: "300px",
              maxWidth: "max-content",
              justifySelf: "center",
              padding: "20px",
              overflowX: "auto",
            }}
          >
            {isLoading ? (
              <ComponentCircleLoader padding="30vh 30vw" />
            ) : selectedOrganization &&
              selectedOrganization.id &&
              invoiceDetails &&
              invoiceDetails.id ? (
              <PreviewPDFView
                PDFView
                invoiceDetails={invoiceDetails}
                selectedOrganization={selectedOrganization}
                invoiceConfig={invoiceConfig}
              />
            ) : null}
          </Container>
        </CommonFlex>
      </ContainerNew>
    </div>
  );
};

export default InvoiceClientView;